import { getBucket } from './bucketSelectors';

export const getState = state => state.bucketSettings;

export const getName = state => {
    const { newBucketName } = getState(state);
    if (newBucketName !== undefined) {
        return newBucketName;
    }
    const bucket = getBucket(state);
    return bucket.name;
};

export const getAppsIds = state => {
    const { newAppsIds } = getState(state);
    if (newAppsIds !== undefined) {
        return newAppsIds;
    }
    const bucket = getBucket(state);
    return bucket.visibleInApplications
        .filter(app => !app.hide)
        .map(app => app.id);
};

export const getIsFormValid = state => {
    const name = getName(state);
    const visibleInApplications = getAppsIds(state);
    if (!name.trim() || !visibleInApplications.length) {
        return false;
    }

    return true;
};

export const getIsLoading = state => getState(state).loading;

export const getError = state => getState(state).error;



// WEBPACK FOOTER //
// ./src/selectors/bucketSettingsSelectors.js